<template>
  <div class="main">
    <div class="order">

        
      <div class="order-item">
        <div class="ub ub-ac2">
          <div>
            <img src="../../assets/img/1.png" class="photo" />
            <span class="money">￥<label>166</label></span>
          </div>
          <img
            src="../../assets/img/关闭 (2).png"
            class="close-img"
            @click="back()"
          />
        </div>

        <div>
          <span class="key">服务类型</span>
          <div>
            <span
              @click="chosesex('文字语音条', 0)"
              :class="chosed == 0 ? 'tag-on' : 'tag'"
              >文字语音条</span
            >
            <span
              @click="chosesex('语音通话', 1)"
              :class="chosed == 1 ? 'tag-on' : 'tag'"
              >语音通话</span
            >
            <span
              @click="chosesex('游戏陪玩', 2)"
              :class="chosed == 2 ? 'tag-on' : 'tag'"
              >游戏陪玩</span
            >
          </div>
        </div>

        <div style="margin-bottom: 0.8em">
          <span class="key">时长</span>
          <div>
            <span
              @click="chosesex2('一小时', 0)"
              :class="chosed2 == 0 ? 'time-on' : 'time'"
              >一小时</span
            >
            <span
              @click="chosesex2('一天', 1)"
              :class="chosed2 == 1 ? 'time-on' : 'time'"
              >一天</span
            >
            <span
              @click="chosesex2('一周', 2)"
              :class="chosed2 == 2 ? 'time-on' : 'time'"
              >一周</span
            >
            <span
              @click="chosesex2('一个月', 3)"
              :class="chosed2 == 3 ? 'time-on' : 'time'"
              >一个月</span
            >
          </div>
        </div>

        <div class="">
          <div class="ub ub-pc">
            <span style="color: red">*</span>
            <span style="font-size: 0.95em">你的微信号</span>
            <input
              type="text"
              placeholder="请输入微信号"
              class="input-verify"
            />
          </div>
        </div>

        <div class="btn-block ub ub-pc ub-ac2">
          <div class="mon">
            <span class="sp1">总价:</span>
            <span class="sp2">￥166</span>
          </div>
          <span class="btn ub ub-ac ub-pc">立即下单</span>
        </div>
      </div>



    </div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      type: "",
      chosed: "",
      chosed2: "",
      time: "",
    };
  },
  mounted() {},
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    chosesex(type, chosed) {
      this.type = type;
      this.chosed = chosed;
    },
    chosesex2(time, chosed2) {
      this.time = time;
      this.chosed2 = chosed2;
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  background-color: #000;
  width: 100%;
  bottom: 0;
  top: 0;
}
.order {
  background-color: #fff;
  width: 100%;
  position: fixed;
  bottom: 0;
  border-top-left-radius: 0.8em;
  border-top-right-radius: 0.8em;
}
.order-item {
  padding: 0.8em;
}
.photo {
  width: 5em;
  height: 5em;
  margin-right: 0.5em;
  border-radius: 0.3em;
}
.close-img {
  width: 1.5em;
  height: 1.5em;
}
.money {
  color: #ee0a24;
}
.key {
  display: inline-block;
  font-size: 0.95em;
  margin: 0.8em 0 0.4em 0;
  color: #333;
}
.tag-on {
  font-size: 0.8em;
  display: inline-block;
  padding: 0.4em 0.5em;
  background-color: #fee7e9;
  color: #ee0a24;
  border-radius: 0.4em;
  margin-right: 0.8em;
}
.tag {
  font-size: 0.8em;
  display: inline-block;
  padding: 0.4em 0.5em;
  background-color: #dfdfdf;
  color: #888;
  border-radius: 0.4em;
  margin-right: 0.8em;
}
.time {
  font-size: 0.8em;
  display: inline-block;
  padding: 0.4em 0.5em;
  background-color: #dfdfdf;
  color: #888;
  border-radius: 0.4em;
  margin-right: 0.8em;
}
.time-on {
  font-size: 0.8em;
  display: inline-block;
  padding: 0.4em 0.5em;
  background-color: #fee7e9;
  color: #ee0a24;
  border-radius: 0.4em;
  margin-right: 0.8em;
}
.count {
  margin: 0.8em 0 0.4em 0;
}
.count span {
  font-size: 0.8em;
  display: inline-block;
  background-color: #f7f8fa;
  color: #333;
  border-radius: 0.4em;
  width: 2em;
  height: 2em;
  text-align: center;
  line-height: 2em;
}
.tag2 {
  margin: 0 0.5em;
}

.input-verify {
  background-color: transparent;
  margin-left: 0.8em;
  border: 0;
  outline: 0;
  font-size: 0.9em;
}
.wechat {
  margin: 1em 0;
}
.wechat-img {
  width: 1em;
  margin-right: 0.5em;
}
.rad {
  border: 2px solid #c9cacd;
  width: 1.1em;
  height: 1.1em;
  border-radius: 50%;
  background-color: #fff;
  /* padding: .2em; */
}
.rad_img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.mon span {
  font-size: 0.95em;
}
.mon .sp1 {
  color: #333;
}
.mon .sp2 {
  color: #ff4444;
}
.btn-block {
  margin-top: 1.8em;
}
.btn {
  width: 35%;
  background-color: #42a5f5;
  height: 2.6em;
  color: #fff;
  border-radius: 1.3em;
  font-size: 0.95em;
}
</style>